import store from '@/store';
import axios from '@/plugins/axios';

export default {
  getClientCategories: async function () {
    try {
      store.commit('SET_PORTFOLIO_CATEGORIES', []);
      let response = await axios({
        method: 'post',
        url: '/api/portfolio/categories',
      });
      store.commit(
        'SET_PORTFOLIO_CATEGORIES',
        response.data.categories || []
      );
    } catch {
      console.log('error fetching categories');
    }
  },

  getClientSectors: async function () {
    try {
      store.commit('SET_PORTFOLIO_SECTORS', []);
      let response = await axios({
        method: 'post',
        url: '/api/portfolio/sectors',
      });
      store.commit(
        'SET_PORTFOLIO_SECTORS',
        response.data.sectors || []
      );
    } catch {
      console.log('error fetching sectors');
    }
  },
  getClientIndustries: async function () {
    try {
      store.commit('SET_PORTFOLIO_INDUSTRIES', []);
      let response = await axios({
        method: 'post',
        url: '/api/portfolio/industries',
      });
      store.commit(
        'SET_PORTFOLIO_INDUSTRIES',
        response.data.industries || []
      );
    } catch {
      console.log('error fetching industries');
    }
  },

  getClients: async function () {
    try {
      store.commit('SET_PORTFOLIO_CLIENTS', []);
      let response = await axios({
        method: 'post',
        url: '/api/portfolio/clients',
      });
      store.commit(
        'SET_PORTFOLIO_CLIENTS',
        response.data.clients || []
      );
    } catch {
      console.log('error fetching clients');
    }
  },
};
